function normalize(value) {
  return String(value || "").toLowerCase();
}

export const FUEL_FILTERS = [
  { slug: "diesel", name: "Diesel", title: "Diesel-Fahrzeuge", phrase: "Diesel", icon: "diesel", match: (vehicle) => normalize(vehicle.fuel).includes("diesel") && !normalize(vehicle.fuel).includes("hybrid") },
  { slug: "benzin", name: "Benzin", title: "Benzin-Fahrzeuge", phrase: "Benzin", icon: "benzin", match: (vehicle) => /benzin|super|otto/.test(normalize(vehicle.fuel)) && !normalize(vehicle.fuel).includes("hybrid") },
  { slug: "elektro", name: "Elektro", title: "Elektrofahrzeuge", phrase: "Elektro", icon: "elektro", match: (vehicle) => /elektr/.test(normalize(vehicle.fuel)) && !normalize(vehicle.fuel).includes("hybrid") },
  { slug: "hybrid", name: "Hybrid", title: "Hybrid-Fahrzeuge", phrase: "Hybrid", icon: "hybrid", match: (vehicle) => normalize(vehicle.fuel).includes("hybrid") }
];

export const GEARBOX_FILTERS = [
  { slug: "automatik", name: "Automatik", title: "Automatik-Fahrzeuge", phrase: "Automatik", icon: "automatik", match: (vehicle) => normalize(vehicle.gearbox).includes("automatik") },
  { slug: "schaltgetriebe", name: "Schaltgetriebe", title: "Fahrzeuge mit Schaltgetriebe", phrase: "Schaltgetriebe", icon: "schaltgetriebe", match: (vehicle) => /schalt|manuell/.test(normalize(vehicle.gearbox)) }
];

export function vehicleMatchesFuel(vehicle, slug) {
  if (!slug) return true;
  const filter = FUEL_FILTERS.find((entry) => entry.slug === slug);
  return filter ? filter.match(vehicle) : true;
}

export function vehicleMatchesGearbox(vehicle, slug) {
  if (!slug) return true;
  const filter = GEARBOX_FILTERS.find((entry) => entry.slug === slug);
  return filter ? filter.match(vehicle) : true;
}

export function buildResultsTitle({ brandName, fuelSlug, gearboxSlug }) {
  const fuel = FUEL_FILTERS.find((entry) => entry.slug === fuelSlug);
  const gearbox = GEARBOX_FILTERS.find((entry) => entry.slug === gearboxSlug);
  if (!brandName && !fuel && !gearbox) return "Alle Fahrzeuge";
  if (brandName && !fuel && !gearbox) return `${brandName} Fahrzeuge`;
  if (!brandName && fuel && !gearbox) return fuel.title;
  if (!brandName && !fuel && gearbox) return gearbox.title;
  const subject = [brandName, fuel ? fuel.phrase : ""].filter(Boolean).join(" ");
  return gearbox ? `${subject} mit ${gearbox.phrase}` : `${subject}-Fahrzeuge`;
}

export function formatResultCount(count) {
  if (count === 0) return "Keine Fahrzeuge gefunden";
  return count === 1 ? "1 Fahrzeug gefunden" : `${count} Fahrzeuge gefunden`;
}
